module.exports = __webpack_public_path__ + "static/media/payFarmacorp.e0e277ca.png";